import React, { useContext } from 'react';
import { Layout } from 'antd';
import { SelectedWebsiteContext } from '../../trackedWebsites/ContextWrapper';
import TrackedWebsites from '../../trackedWebsites/TrackedWebsites';
import SiteOutage from '../SiteOutage';

const { Content } = Layout;

export default function SiteOutagePage() {
    const { selectedWebsite } = useContext(SelectedWebsiteContext);

    return (
        <Content className="general-layout-content">
            <TrackedWebsites
                tabContent={<SiteOutage selectedWebsite={selectedWebsite!} />}
                destroyInactiveTabs={true}
            />
        </Content>
    );
}
